import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";

export default function useGetChatHistoryList() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [chatHistoryList, setChatHistoryList] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [changeConversation, setChangeConversation] = useState(false);

  function setLoading(value) {
    setHistoryLoading(value);
    setChangeConversation(value);
  }

  function getChatHistoryList(conversationKey) {
    fetchWrapper({
      endpoint_url: "chat_history/getChatHistoryList",
      method: "GET",
      set_content_type_header: false,
      setLoading: (value) => setLoading(value),
      params: {
        conversation_id: conversationKey,
      },
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          setChatHistoryList(fetch_output.data);
        } else {
          showMessage({ message: fetch_output.erro });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "get chat history list" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "get chat history list" });
      },
    });
  }

  return {
    getChatHistoryList,
    chatHistoryList,
    setChatHistoryList,
    historyLoading,
    changeConversation,
    setChangeConversation,
  };
}
